import { FileUploadInfo } from '../../data/services/FileUploadManager';
import { useAppDispatch } from '../hooks';
import { clearAllFilesReducer, clearUploadedFilesReducer, clearUploadReducer, FileUploadUrlInfo, setUploadStartedReducer, setUploadUrlInfoReducer, updateFileUploadProgressReducer, updateFileUploadTimeReducer, uploadFilesReducer } from '../reducers/uploadReducer';

export interface UploadActions {
    uploadFiles: (fileUploads: FileUploadInfo[]) => void;   
    setUploadStarted: (fileId: string) => void;
    updateFileUploadProgress: (fileId: string, progress: number) => void;
    updateFileUploadTime: (fileId: string, uploadTime: number) => void;
    setUploadUrlInfo: (urls: FileUploadUrlInfo) => void;
    clearUpload: (fileId: string) => void;
    clearUploadedFiles: () => void;
    clearAllFiles: () => void;
}

export const useUploadActions = ():UploadActions => {

    const dispatch = useAppDispatch();

    const uploadFiles = (fileUploads: FileUploadInfo[]) => {
        dispatch(uploadFilesReducer(fileUploads));
    }

    const setUploadStarted = (fileId: string) => {
        dispatch(setUploadStartedReducer({ fileId }));
    }

    const updateFileUploadProgress = (fileId: string, progress: number) => {
        dispatch(updateFileUploadProgressReducer({ fileId, progress }));
    }

    const updateFileUploadTime = (fileId: string, uploadTime: number) => {
        dispatch(updateFileUploadTimeReducer({ fileId, uploadTime }));
    }

    const setUploadUrlInfo = (urls: FileUploadUrlInfo) => {
        dispatch(setUploadUrlInfoReducer(urls));
    }
        
    const clearUpload = (fileId: string) => {
        dispatch(clearUploadReducer({ fileId }));
    }

    const clearUploadedFiles = () => {
        dispatch(clearUploadedFilesReducer());
    }

    const clearAllFiles = () => {
        dispatch(clearAllFilesReducer());
    }

    return {
        uploadFiles,
        setUploadStarted,
        updateFileUploadProgress,
        updateFileUploadTime,
        setUploadUrlInfo,
        clearUpload,
        clearUploadedFiles,
        clearAllFiles
    };
}